// extracted by mini-css-extract-plugin
module.exports = {"FooterMenu":"FooterMenu_FooterMenu__2VrvE","FooterMenuList":"FooterMenu_FooterMenuList__2fiKv"};